import api, { fetchData } from './api';
import Paginacao from '../types/paginacao';
import Branch from '../types/branch';

export interface BranchApiResponse {
  data: Branch;
  messages: any; 
}

export const getBranchesPaginated = async (
    paginacao: Paginacao
  ) => {
    try {
      const endpoint: string = '/Branch/all/paginado';
      const params: Record<string, any> = {
        pageNum: paginacao.pageNum + 1,
        quantityPerPage: paginacao.quantityPerPage,
      };
  
      const response = await fetchData<Branch>(endpoint, params);
  
      return response;
    } catch (error) {
      console.error('Erro ao buscar lista de branches:', error);
      throw error;
    }
};
  
  export const getBranchById = async (id: number) => {
    try {
      const response = await api.get(`/Branch/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Erro ao buscar branch com ID ${id}`, error);
      throw error;
    }
  };

  export const deleteBranch = async (id: number) => {
    try {
      const response = await api.delete(`/Branch/delete/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Erro ao excluir branch com ID ${id}`, error);
      throw error;
    }
  };
  
  export const getBranches = async () => {
    try {
      const endpoint: string = 'Branch/all';
      const response = await fetchData<Branch>(endpoint, {});
      return response;
    } catch (error) {
      console.error(`Erro ao buscar branch`, error);
      throw error;
    }
  };
  
  export const createBranch = async (branch: Branch) => {
    try {
      const response = await api.post('Branch', branch);
      return response.data;
    } catch (error) {
      console.error('Erro ao cadastrar branch');
      throw error;
    }
  };
  
  export const updateBranch = async (id: number, branch: Branch) => {
    try {
      const response = await api.put(`/Branch/update/${id}`, branch);
      return response.data;
    } catch (error: any) {
      console.error('Error updating branch:', {
        status: error.response?.status,
        data: error.response?.data,
        message: error.message
      });
      throw error;
    }
  };